'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthenticationActionTypes = (0, _keyMirror2.default)({
  DETECT_AUTH_AUTHED: null,
  DETECT_AUTH_UNAUTHED: null,

  AUTHENTICATION_SUCCEEDED: null,
  AUTHENTICATION_FAILED: null
});

exports.default = AuthenticationActionTypes;
module.exports = exports['default'];